// @flow

import Config from '@insolus/config';

type Options = $Shape<{|
    replace?: boolean
|}>;

const staticRedirect = (url: string, options: Options = {}) => {
    const defaults: Options = { replace: false };
    const _options = { ...defaults, ...options };

    let _url = url;
    if (!/^[a-z][a-z0-9+\-.]*:\/\//i.test(url)) {
        // eslint-disable-next-line prefer-template
        _url = Config.get('location.base', '') + '/' + url;
        _url = _url.replace(/\/\//g, '/');
    }

    const method = _options.replace ? 'replace' : 'assign';
    window.location[method](_url);
};

export default staticRedirect;
